/**
 * Cell logs React Query hook
 * Fetches and auto-refreshes crawl step logs for a specific cell
 */

import { useQuery } from '@tanstack/react-query';
import * as jobsApi from '@/services/jobsApi';

/**
 * Query keys for cell logs
 */
export const cellLogsKeys = {
  all: ['cell-logs'] as const,
  logs: (jobId: string, cellId: string) => [...cellLogsKeys.all, jobId, cellId] as const,
};

/**
 * Hook to fetch cell logs
 * Auto-refreshes every 2 seconds when the cell is being processed
 */
export function useCellLogs(jobId: string | undefined, cellId: string | undefined, isProcessing = false) {
  return useQuery({
    queryKey: cellLogsKeys.logs(jobId || '', cellId || ''),
    queryFn: () => jobsApi.getCellLogs(jobId!, cellId!),
    enabled: !!jobId && !!cellId,
    staleTime: 1000,
    // Auto-refresh every 2 seconds if the cell is being processed
    refetchInterval: isProcessing ? 2000 : false,
  });
}

export default useCellLogs;
